import { defineQuery, useQuery, useQueryCache } from "@pinia/colada";
import type { RemoveFromWaitlist, Waitlist } from "@/schemas/waitlist";

export const useWaitlist = defineQuery(() => {
  const { data: waitlist, isLoading, status, error } = useQuery<Waitlist, Error, Waitlist>({
    key: () => ["waitlist"],
    query: async () => ajaxRequest<Waitlist>("get_waitlist"),
    placeholderData: () => ({ notifications: [] }),
  });
  const isInWaitlist = computed(() => (product_id: number) => waitlist.value?.notifications.some(({ product }) => product.product_id === product_id));
  return { waitlist, isLoading, status, error, isInWaitlist };
});

export function useAddToWaitlistForm() {
  return useFormHandler<{ message: string }>({
    schema: addToWaitlistSchema,
    action: "add_to_waitlist",
  });
}

export function useRemoveFromWaitlist() {
  const queryCache = useQueryCache();
  const { mutate, ...rest } = useMutationHandler<{ waitlist: Waitlist }, RemoveFromWaitlist>({
    action: "remove_from_waitlist",
    icons: { pending: "i-lucide-trash" },
    onSuccess: ({ waitlist }) => {
      queryCache.setQueryData(["waitlist"], waitlist);
    },
  });
  function onRemoveFromWaitlist(params: RemoveFromWaitlist) {
    mutate(params);
  }
  return { onRemoveFromWaitlist, ...rest };
}
